import Auth from "./auth";

const auth = new Auth();

export default auth;
